@if (layout === 'row') {
  <article
    class="pg-action-card pg-action-card--row"
    [class]="'pg-action-card pg-action-card--' + variant + ' pg-action-card--row' + (disabled ? ' pg-action-card--disabled' : '')"
    [attr.aria-label]="ariaLabel || (disabled ? title + ' unavailable' : title)"
    [attr.aria-disabled]="disabled ? 'true' : null"
  >
    <span class="pg-action-card__icon" aria-hidden="true">
      <mat-icon>{{ icon }}</mat-icon>
    </span>
    <span class="pg-action-card__body">
      <span class="pg-action-card__title">{{ title }}</span>
      <span class="pg-action-card__description">{{ description }}</span>
    </span>
    @if (disabled) {
      <span class="pg-action-card__action pg-action-card__unavailable">Unavailable <mat-icon class="pg-action-card__arrow" aria-hidden="true">lock</mat-icon></span>
    } @else if (hasActionRoute()) {
      <a class="pg-action-card__action" [routerLink]="rowRoute()" [state]="rowState()"
        [attr.aria-label]="actionAriaLabel || actionLabel + ' ' + title">
        <span>{{ actionLabel }}</span>
        <mat-icon class="pg-action-card__arrow" aria-hidden="true">{{ actionIcon }}</mat-icon>
      </a>
    } @else {
      <button type="button" class="pg-action-card__action"
        [attr.aria-label]="actionAriaLabel || actionLabel + ' ' + title" (click)="action.emit()">
        <span>{{ actionLabel }}</span>
        <mat-icon class="pg-action-card__arrow" aria-hidden="true">{{ actionIcon }}</mat-icon>
      </button>
    }
  </article>
} @else {
  @if (disabled) {
    <article
      class="pg-action-card pg-action-card--disabled"
      [class]="'pg-action-card pg-action-card--' + variant + ' pg-action-card--disabled'"
      [attr.aria-label]="ariaLabel || title + ' unavailable'"
      aria-disabled="true"
    >
      <span class="pg-action-card__icon" aria-hidden="true">
        <mat-icon>{{ icon }}</mat-icon>
      </span>
      <span class="pg-action-card__body">
        <span class="pg-action-card__title">{{ title }}</span>
        <span class="pg-action-card__description">{{ description }}</span>
      </span>
      <span class="pg-action-card__action pg-action-card__unavailable">Unavailable <mat-icon class="pg-action-card__arrow" aria-hidden="true">lock</mat-icon></span>
    </article>
  } @else {
    <a
      class="pg-action-card"
      [class]="'pg-action-card pg-action-card--' + variant"
      [routerLink]="route"
      [state]="state"
      [attr.aria-label]="ariaLabel || title"
    >
      <span class="pg-action-card__icon" aria-hidden="true">
        <mat-icon>{{ icon }}</mat-icon>
      </span>
      <span class="pg-action-card__body">
        <span class="pg-action-card__title">{{ title }}</span>
        <span class="pg-action-card__description">{{ description }}</span>
      </span>
      <span class="pg-action-card__action" aria-hidden="true">Open <mat-icon class="pg-action-card__arrow">{{ actionIcon }}</mat-icon></span>
    </a>
  }
}
